module.exports = __webpack_public_path__ + "static/media/player_cn.b87e1245.png";